// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TextWithActions__wrapper__2WnvQ","text":"TextWithActions__text__2gs6z","item":"TextWithActions__item__MaOj-","actions":"TextWithActions__actions__1Axzi"};